export default __webpack_public_path__ + "static/media/sun-icon.0b5ce574.svg";